import { useMemo } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

export const useAppDispatch = useDispatch
export const useAppSelector = useSelector

export function useActions(actionCreators) {
    const dispatch = useAppDispatch()

    return useMemo(
        () => bindActionCreators(actionCreators, dispatch),
        [dispatch, actionCreators]
    )
}
